import React from "react";

const items = [
  "Web Apps",
  "SaaS MVPs",
  "AI Integrations",
  "Landing Pages",
  "Brand Systems",
  "Rapid Prototypes",
  "Automation",
  "Social Media",
];

export default function Marquee() {
  // Duplicate twice for seamless loop
  return (
    <section
      data-testid="marquee-section"
      className="relative bg-[#0D0D0D] text-[#FDFBF7] py-5 overflow-hidden border-y-[3px] border-[#0D0D0D]"
    >
      <div className="marquee-track">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex shrink-0 items-center">
            {items.map((it, i) => (
              <React.Fragment key={`${dup}-${i}`}>
                <span className="mx-8 font-display font-black uppercase text-3xl sm:text-4xl tracking-tight">
                  {it}
                </span>
                <span className="text-[#FFD800] text-3xl">✺</span>
              </React.Fragment>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
